export const ENABLE_VISUAL_ERROR = 'enableVisualError'
export const LED_PROGRESS_BAR = 'ledProgressBar'
export const ATP_MODE = 'atpMode'
export const PASSWORD = 'password'
